import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FixedBanner from "@Shared/components/general/fixed-banner.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { IS_USAGE_RESTRICTED, GET_USAGE_REMAINING_FOR_PAGE, GET_USAGE_LIMIT_FOR_PAGE } from "../../store/account-plan-getters";
import { LOAD_PLAN_LIMIT } from "../../store/account-plan-actions";
import { ACCOUNT_PLAN_IS_FREE } from "@Broker/@Modules/main/store/account/account-getters";
import AccountUsageMessage from "./account-usage-message.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AccountUsageBanner",
  components: {
    FixedBanner,
    AccountUsageMessage
  },
  props: {
    page: {
      type: String,
      default: ""
    },
    positionFixed: {
      type: Boolean,
      default: true
    },
    sideRight: {
      type: Boolean,
      default: true
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("AccountPlanStore", {
    currentPagePlan(state) {
      return state.currentPagePlan;
    }
  })), mapGetters("AccountPlanStore", [IS_USAGE_RESTRICTED, GET_USAGE_REMAINING_FOR_PAGE, GET_USAGE_LIMIT_FOR_PAGE])), mapGetters("AccountStore", [ACCOUNT_PLAN_IS_FREE])), {}, {
    currentPage() {
      return this.page || this.currentPagePlan;
    },
    usageRestricted() {
      return this.IS_USAGE_RESTRICTED(this.currentPage);
    },
    showBanner() {
      if (!this.ACCOUNT_PLAN_IS_FREE) return false;
      return !!this.currentPage;
    },
    remainingUsages() {
      return this.GET_USAGE_REMAINING_FOR_PAGE(this.currentPage);
    },
    maxUsage() {
      return this.GET_USAGE_LIMIT_FOR_PAGE(this.currentPage);
    },
    currentPageLabel() {
      return this.$t("account.accountUsage.pages")[this.currentPage];
    }
  }),
  methods: _objectSpread({}, mapActions("AccountPlanStore", [LOAD_PLAN_LIMIT]))
});